<template>
  <div class="canvas-selector__navbar flex items-center gap-2">
    <CButton
      v-for="t in availableTabs"
      :key="t.type"
      secondary
      :type="t.type === activeSelectionType ? 'primary' : 'default'"
      @click="onTypeSelect(t.type)"
    >
      {{ t.text }}
    </CButton>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, type ToRefs } from 'vue'
import { useI18n } from 'vue-i18n'

import CButton from '@lib/components/CButton/CButton.vue'
import type { AppProps, CanvasSelectionType } from '@canvas-selector/appTypes'
import useAppStore from '@canvas-selector/stores/app'
import { availableSelectorTypes } from '@canvas-selector/constants'

const appProps = inject<ToRefs<AppProps>>('appProps')
const { t } = useI18n()
const texts = {
  canvas: t('canvasUI.canvasSelectorApp.navbar.canvas'),
  'canvas-template': t('canvasUI.canvasSelectorApp.navbar.canvasTemplate'),
  section: t('canvasUI.canvasSelectorApp.navbar.section'),
  'section-template': t('canvasUI.canvasSelectorApp.navbar.sectionTemplate'),
} as const
const availableTabs = computed(() =>
  availableSelectorTypes
    .filter((t) => (appProps?.allowedSelectorTypes?.value ? appProps?.allowedSelectorTypes?.value?.includes(t) : true))
    .map((type) => ({ type, text: texts[type] })),
)
const { activeSelectionType } = useAppStore()

function onTypeSelect(type: CanvasSelectionType) {
  activeSelectionType.value = type
}
</script>
